export default __webpack_public_path__ + "static/media/modalbackground.6c79299c.png";